module.exports = __webpack_public_path__ + "static/media/climatizacion-coche.d528fd86.png";